// src/components/RecentPosts.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { blogService } from '../../../services/blogService';

const RecentPosts = () => {
  const [recentPosts, setRecentPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRecentPosts = async () => {
      try {
        const data = await blogService.getRecentPosts();
        if (data === null) {
          setError('Failed to load recent posts');
          return;
        }
        setRecentPosts(data);
      } catch (err) {
        console.error('Error fetching recent posts:', err);
        setError('Failed to load recent posts');
      } finally {
        setLoading(false);
      }
    };

    fetchRecentPosts();
  }, []);

  if (loading) {
    return (
      <div className="p-4 bg-white rounded-lg shadow-lg">
        <h2 className="text-lg font-bold">Recent Posts</h2>
        <div className="mt-2">Loading...</div>
      </div>
    );
  }

  if (error || !recentPosts || recentPosts.length === 0) {
    return null;
  }

  return (
    <div className="p-4 bg-white rounded-lg shadow-lg">
      <h2 className="text-lg font-bold">Recent Posts</h2>
      <ul className="mt-2 space-y-2">
        {recentPosts.map((post) => (
          <li key={post._id} className="border-b pb-2 last:border-b-0">
            <Link 
              to={`/blog/${post.urlSlug}`} 
              className="text-blue-500 hover:text-blue-700 block"
            >
              {post.title}
            </Link>
            {post.publishedAt && (
              <span className="text-gray-500 text-sm">
                {new Date(post.publishedAt).toLocaleDateString()}
              </span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RecentPosts;
